import { QRCodeSVG } from "qrcode.react";
import { MessageCircle, Heart } from "lucide-react";

/* Invite friends to TravelerPulse — QR + WhatsApp message with
   the "What & Why" story and the My Travel Hub features article. */
export default function InviteFriends({ compact = false }) {
  const origin = window.location.origin;
  const mainLink = origin; // direct site link — no shortener
  const msg = encodeURIComponent(
    `I plan all my trips on TravelerPulse.pro \u2708\uFE0F \u2014 AI trip planner, day-by-day itineraries, offline travel mode & more.\n\n` +
    `\u2022 Explore it: ${mainLink}\n` +
    `\u2022 What & why TravelerPulse: ${origin}/explore-plan-share-travel\n` +
    `\u2022 My Travel Hub features: ${origin}/my-travel-hub-guide`
  );
  return (
    <div className={`border border-violet-200 bg-violet-50/50 ${compact ? "p-4" : "p-5"} flex flex-wrap items-center gap-4`} data-testid="invite-friends">
      <div className="shrink-0 bg-white p-2 border border-zinc-200 rounded-lg">
        <QRCodeSVG value={mainLink} size={compact ? 72 : 92} level="M" />
      </div>
      <div className="flex-1 min-w-[200px]">
        <div className="font-heading font-900 text-violet-900 flex items-center gap-1.5"><Heart className="w-4 h-4 text-rose-500" /> Tell friends about TravelerPulse</div>
        <p className="text-xs text-muted-foreground mt-0.5">
          They scan the QR — or send them the link with our story ("What &amp; Why") and everything My Travel Hub can do.
        </p>
        <a href={`https://wa.me/?text=${msg}`} target="_blank" rel="noreferrer" data-testid="invite-friends-whatsapp"
          className="mt-2.5 inline-flex items-center gap-1.5 bg-[#25D366] text-white px-3.5 py-2 text-sm font-700 rounded-full hover:opacity-90 transition-opacity">
          <MessageCircle className="w-4 h-4" /> Share on WhatsApp
        </a>
      </div>
    </div>
  );
}
